import axios from '../http'

function query(data) {
    return axios.post('/sys/genID/query', data);
}
function get(id) {
    return axios.get('/sys/genID/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/genID/add', data);
}

function update(data) {
    return axios.post('/sys/genID/update', data);
}

function del(data) {
    return axios.post('/sys/genID/del', data);
}
export default {
    query,
    get,
    add,
    update,
    del
}